import meter1 from "../assets/img/instagram.png";
import meter2 from "../assets/img/tik-tok.png";
import meter3 from "../assets/img/discord.png";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
import colorSharp from "../assets/img/color-sharp.png"

export const Footer = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="footer" id="footer">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="footer-bx wow zoomIn">
                        <h5>Ultimi metodi</h5>
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme footer-slider">
                            <div className="item">
                                <a href="/SondaggiRetribuiti"><h5>Sondaggi retribuiti</h5></a>
                            </div>
                            <div className="item">
                                <a href="/AffiliateMarketing"><h5>Affiliate Marketing</h5></a>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}
